import { ref, watch, resolveComponent, openBlock, createBlock, normalizeClass, withCtx, createCommentVNode, createVNode, createElementBlock, Fragment, renderList, createElementVNode, toDisplayString } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { INPUT_EVENT, CHANGE_EVENT, CLOSE_EVENT, OPEN_EVENT } from './utils/constants';
import Swiper from './swiper';
import Popup from './popup';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * 是否展示预览图片
   */
  modelValue: propTypes["boolean"]().def(false),
  /**
   * 图片列表
   */
  images: propTypes.array().re(),
  /**
   * 当前图片索引
   */
  initIndex: propTypes.number().def(0),
  /**
   * 是否开启循环播放
   */
  loop: propTypes["boolean"]().def(true),
  /**
   * 是否展示分页指示器
   */
  showIndicators: propTypes["boolean"]().def(true),
  /**
   * 是否将绝对定位的移到body节点下
   */
  transferDom: propTypes["boolean"]().def(true),
  /**
   * 对应swiper的duration
   */
  swipeDuration: propTypes.number().def(500)
};
var emits = [INPUT_EVENT, CHANGE_EVENT, CLOSE_EVENT, OPEN_EVENT];

var _components;
var _createComponent = createComponent('image-preview'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: (_components = {}, _defineProperty(_components, Swiper.name, Swiper), _defineProperty(_components, Popup.name, Popup), _components),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    // swiper dom
    var swiperRef = ref();
    // 当前展示图片的索引值
    var activeIndex = ref(0);
    /**
     * @description: 图片切换
     * @param {Number} index
     * @return {*}
     */
    function onChange(index) {
      if (activeIndex.value !== index) {
        // 当前图片数量
        var maxNoIndex = props.images && props.images.length - 1;
        // 如果传入的索引值大于当前图片数量，则展示最后一张图
        activeIndex.value = index > maxNoIndex ? maxNoIndex : index;
        emit(CHANGE_EVENT, activeIndex.value);
      }
    }
    /**
     * @description: 关闭逻辑
     * @param {*}
     * @return {*}
     */
    function onClose() {
      emit(INPUT_EVENT, false);
      emit(CLOSE_EVENT);
    }
    watch(function () {
      return props.initIndex;
    }, function (val) {
      onChange(val);
    }, {
      immediate: true
    });
    watch(function () {
      return props.modelValue;
    }, function (val) {
      if (val) {
        onChange(props.initIndex);
        var swiper = swiperRef.value;
        swiper && swiper.to(activeIndex.value, true);
        emit(OPEN_EVENT);
      }
    });
    return {
      className: className,
      swiperRef: swiperRef,
      activeIndex: activeIndex,
      onChange: onChange,
      onClose: onClose
    };
  }
});

var _hoisted_1 = ["src"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_swiper = resolveComponent("sp-swiper");
  var _component_sp_popup = resolveComponent("sp-popup");
  return openBlock(), createBlock(_component_sp_popup, {
    modelValue: _ctx.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.modelValue = $event;
    }),
    "class": normalizeClass(_ctx.className),
    maskClass: "".concat(_ctx.className, "__mask"),
    transition: "fade",
    transferDom: _ctx.transferDom,
    onClick: _ctx.onClose
  }, {
    "default": withCtx(function () {
      return [createCommentVNode(" 图片区域 "), createVNode(_component_sp_swiper, {
        "class": normalizeClass("".concat(_ctx.className, "__swiper")),
        indicatorShow: false,
        loop: _ctx.loop,
        duration: _ctx.swipeDuration,
        onChange: _ctx.onChange,
        ref: "swiperRef"
      }, {
        "default": withCtx(function () {
          return [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.images, function (item, index) {
            return openBlock(), createElementBlock("div", {
              "class": normalizeClass("".concat(_ctx.className, "__swiper_item")),
              key: index
            }, [createElementVNode("img", {
              "class": normalizeClass("".concat(_ctx.className, "__swiper_item_img")),
              src: item
            }, null, 10 /* CLASS, PROPS */, _hoisted_1)], 2 /* CLASS */);
          }), 128 /* KEYED_FRAGMENT */))];
        }),

        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class", "loop", "duration", "onChange"]), createCommentVNode(" 分页指示器 "), _ctx.showIndicators ? (openBlock(), createElementBlock("div", {
        key: 0,
        "class": normalizeClass("".concat(_ctx.className, "__indicator"))
      }, toDisplayString(_ctx.activeIndex + 1) + "/" + toDisplayString(_ctx.images.length), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "class", "maskClass", "transferDom", "onClick"]);
}

script.render = render;
script.__file = "components/src/component/image-preview/image-preview.vue";

/*
 * @Description: ImagePreivew 导出文件
 * @Author: duqiao@kuaishou.com
 * @Date: 2022-03-28 21:19:55
 * @LastEditors: zhoushichao@kuaishou.com
 * @LastEditTime: 2023-02-02 11:04:01
 */
var _ImagePreview = script;

export { _ImagePreview as default };
